import { get, post, del } from "../assets/functions";

export default {
    namespaced: true,
    state: {
        recordings: [],
        currentRecording: null,
        recordingToDelete: null,
        loading: false,
        uploadProgress: 0,
    },
    mutations: {
        setRecordings(state, recordings) {
            state.recordings = recordings;
        },
        setCurrentRecording(state, recording) {
            state.currentRecording = recording;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setUploadProgress(state, progress) {
            state.uploadProgress = progress;
        },
        addRecording(state, recording) {
            state.recordings.unshift(recording);
        },
        removeRecording(state, recordingId) {
            state.recordings = state.recordings.filter(r => r.id !== recordingId);
        },
        updateRecording(state, updatedRecording) {
            const index = state.recordings.findIndex(r => r.id === updatedRecording.id);
            if (index !== -1) {
                state.recordings.splice(index, 1, updatedRecording);
            }
        },
        setRecordingToDelete(state, recording) {
            state.recordingToDelete = recording;
        },
    },
    actions: {
        async fetchRecordings({ commit }) {
            commit("setLoading", true);
            try {
                const response = await get("/api/recordings");
                const recordings = Array.isArray(response) ? response : [];
                commit("setRecordings", recordings);
                return response;
            } catch (error) {
                console.error("Error fetching recordings:", error);
                commit("setRecordings", []);
                return { status: "error", message: error.message };
            } finally {
                commit("setLoading", false);
            }
        },
        async getRecordingDetails({ commit }, recordingId) {
            commit("setLoading", true);
            try {
                const response = await get(`/api/recordings/${recordingId}`);
                
                if (Array.isArray(response) && response.length > 0) {
                    commit("setCurrentRecording", response[0]);
                } else if (response.status === "ok" && response.recording) {
                    commit("setCurrentRecording", response.recording);
                }
                return response;
            } catch (error) {
                console.error("Error fetching recording details:", error);
                return { status: "error", message: error.message };
            } finally {
                commit("setLoading", false);
            }
        },
        async uploadRecording({ commit, dispatch }, { formData, onProgress }) {
            commit("setLoading", true);
            commit("setUploadProgress", 0);
            try {
                const response = await new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    
                    xhr.upload.addEventListener("progress", (e) => {
                        if (e.lengthComputable) {
                            const progress = Math.round((e.loaded / e.total) * 100);
                            commit("setUploadProgress", progress);
                            if (onProgress) onProgress(progress);
                        }
                    });

                    xhr.addEventListener("load", () => {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            try {
                                const response = JSON.parse(xhr.responseText);
                                resolve(response);
                            } catch (e) {
                                reject(new Error("Invalid server response"));
                            }
                        } else {
                            reject(new Error(`Upload failed: ${xhr.status}`));
                        }
                    });

                    xhr.addEventListener("error", () => {
                        reject(new Error("Network error during upload"));
                    });

                    xhr.open("POST", process.env.VUE_APP_URL + "/api/recordings");
                    xhr.withCredentials = true;
                    xhr.send(formData);
                });

                if (response.status === "ok") {
                    await dispatch("fetchRecordings");
                }
                return response;
            } catch (error) {
                console.error("Error uploading recording:", error);
                return { status: "error", message: error.message };
            } finally {
                commit("setLoading", false);
                commit("setUploadProgress", 0);
            }
        },
        async deleteRecording({ commit }, recordingId) {
            try {
                const response = await del(`/api/recordings/${recordingId}`);
                if (response.status === "ok") {
                    commit("removeRecording", recordingId);
                }
                return response;
            } catch (error) {
                console.error("Error deleting recording:", error);
                return { status: "error", message: error.message };
            }
        },
    },
};

